import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface SearchTabProps {
  page: string;
  currentTab: string;
  setCurrentTab: (value: string) => void;
}

const SearchTab = ({ page, currentTab, setCurrentTab }: SearchTabProps) => {
  const navigate = useNavigate();
  return (
    <Container>
      <Inner>
        <TabBox>
          <Tab
            active={currentTab === '간편검색'}
            onClick={() => {
              if (page !== 'main') {
                setCurrentTab('간편검색');
              }
            }}
          >
            간편검색
          </Tab>
          <Tab
            active={currentTab === '종합검색'}
            onClick={() => {
              if (page !== 'main') {
                setCurrentTab('종합검색');
              }
              navigate('/search?type=c');
            }}
          >
            종합검색
          </Tab>
        </TabBox>
      </Inner>
    </Container>
  );
};

export default SearchTab;

const Container = styled.div`
  width: 100%;
  padding: 8px 0 16px;
`;
const Inner = styled.div`
  width: 100%;
  border-bottom: 1px solid #e1e2e4;
`;
const TabBox = styled.div`
  width: 100%;
  padding: 0 16px;
  display: flex;
  flex-direction: row;
`;
const Tab = styled.div<{ active?: boolean }>`
  flex: 1;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#000' : '#a0a0a0')};
  border-bottom: 2px solid ${(props) => (props.active ? '#000' : 'transparent')};
  cursor: pointer;
`;
